import { c as _c } from "react/compiler-runtime";
import type { FootprintVariant } from '@onefootprint/footprint-js-legacy';
import type { LayoutOptions } from '@onefootprint/idv2';
import { LayoutOptionsProvider, useLayoutOptions } from '@onefootprint/idv2';
import type { OnboardingSessionConfig } from '@onefootprint/request-types';
import type React from 'react';
import Content from './components/content';
import FullHeightContainer from './components/full-height-container';
import { LAYOUT_CONTAINER_ID } from './constants';
export const BIFROST_CONTAINER_ID = 'bifrost-container-id';
export type LayoutProps = {
  variant?: FootprintVariant;
  children: React.ReactNode;
  options?: LayoutOptions;
  isSandbox?: boolean;
  isHosted?: boolean;
  fitContent?: boolean;
  onClose?: () => void;
  config?: OnboardingSessionConfig;
  navigationPortalId?: string;
};
type LayoutBodyProps = Pick<LayoutProps, 'variant' | 'children' | 'options' | 'isSandbox' | 'isHosted' | 'fitContent' | 'config'>;
const LayoutBody = t0 => {
  const $ = _c(15);
  const {
    children,
    variant,
    options: t1,
    isSandbox,
    isHosted,
    fitContent,
    config
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? {} : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const options = t2;
  const {
    body: t3
  } = useLayoutOptions();
  const {
    options: t4
  } = t3;
  const {
    fullBleed
  } = t4;
  const isFitContent = variant === "inline" && !!fitContent && !fullBleed;
  const t5 = !!options.hasDesktopBorderRadius;
  let t6;
  if ($[2] !== children || $[3] !== config || $[4] !== isFitContent || $[5] !== isHosted || $[6] !== isSandbox) {
    t6 = <Content isSandbox={isSandbox} isHosted={isHosted} config={config} fitContent={isFitContent}>{children}</Content>;
    $[2] = children;
    $[3] = config;
    $[4] = isFitContent;
    $[5] = isHosted;
    $[6] = isSandbox;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== fullBleed || $[9] !== isFitContent || $[10] !== isSandbox || $[11] !== t5 || $[12] !== t6 || $[13] !== variant) {
    t7 = <FullHeightContainer variant={variant} id={LAYOUT_CONTAINER_ID} hasBorderRadius={t5} isSandbox={isSandbox} fitContent={isFitContent} fullBleed={fullBleed}>{t6}</FullHeightContainer>;
    $[8] = fullBleed;
    $[9] = isFitContent;
    $[10] = isSandbox;
    $[11] = t5;
    $[12] = t6;
    $[13] = variant;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
};
const Layout = t0 => {
  const $ = _c(18);
  const {
    children,
    variant,
    options: t1,
    isSandbox,
    isHosted,
    fitContent,
    onClose,
    config,
    navigationPortalId
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? {} : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const options = t2;
  const t3 = variant === "inline";
  let t4;
  if ($[2] !== options || $[3] !== t3) {
    t4 = {
      ...options,
      hideHeaderButton: t3
    };
    $[2] = options;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== children || $[6] !== config || $[7] !== fitContent || $[8] !== isHosted || $[9] !== isSandbox || $[10] !== options || $[11] !== variant) {
    t5 = <LayoutBody variant={variant} options={options} isSandbox={isSandbox} isHosted={isHosted} fitContent={fitContent} config={config}>{children}</LayoutBody>;
    $[5] = children;
    $[6] = config;
    $[7] = fitContent;
    $[8] = isHosted;
    $[9] = isSandbox;
    $[10] = options;
    $[11] = variant;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== navigationPortalId || $[14] !== onClose || $[15] !== t4 || $[16] !== t5) {
    t6 = <LayoutOptionsProvider options={t4} onClose={onClose} navigationPortalId={navigationPortalId}>{t5}</LayoutOptionsProvider>;
    $[13] = navigationPortalId;
    $[14] = onClose;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  return t6;
};
export default Layout;